// extracted by mini-css-extract-plugin
module.exports = {"arrowButton":"arrow-buttons_arrowButton__Vd4aj","arrowButtons":"arrow-buttons_arrowButtons__8wHJW"};